import { Inbox } from './Inbox/Loadable';
import { Users } from './Users/Loadable';
import { Templates } from './Templates/Loadable';
import { Calls } from './Calls/Loadable';
import { Settings } from './Settings/Loadable';
import { AppStore } from './AppStore/Loadable';
import { Chatbot } from './Chatbot/Loadable';
import { MetaAI } from './MetaAI/Loadable';
import { LambdaStudio } from './LambdaStudio/Loadable';

const PAGES = [
  ['/inbox', Inbox],
  ['/contacts', Users],
  ['/templates', Templates],
  ['/calls', Calls],
  ['/settings', Settings],
  ['/integrations', AppStore],
  ['/chatbot', Chatbot],
  ['/meta-ai', MetaAI],
  ['/ai-studio', LambdaStudio],
] as const;

const EVERYDAY = ['/inbox', '/contacts', '/templates', '/calls', '/settings'];

/** Fetch the page's file ahead of the click, or of the first render reaching its route. */
export const preloadPage = (path: string): void => {
  const target = path === '/' ? '/inbox' : path;
  PAGES.find(
    ([prefix]) => target === prefix || target.startsWith(`${prefix}/`),
  )?.[1].preload();
};

/**
 * The tabs used all day, one per idle moment, so the first click on each finds
 * its file already there and no click ever waits behind this.
 */
export const preloadEverydayPages = (): void => {
  const waiting = [...EVERYDAY];
  const next = () => {
    const path = waiting.shift();
    if (!path) return;
    preloadPage(path);
    whenIdle(next);
  };
  whenIdle(next);
};

const whenIdle = (task: () => void): void => {
  if (typeof window.requestIdleCallback === 'function')
    window.requestIdleCallback(task, { timeout: 3000 });
  else window.setTimeout(task, 300);
};
